/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useMemo, useState, useEffect} from 'react';
// import { useHistory } from 'react-router-dom';
import {DropzoneAreaBase,FileObject} from 'material-ui-dropzone';
import { read, utils, writeFileXLSX } from 'xlsx';
import axios from 'axios';

import {
    Theme,
    Container, 
    MenuItem,
    TextField,
    Button,
    Switch,
    Card, 
    CardHeader, 
    CardActions, 
    CardContent,
    Pagination
} from '@mui/material';

import { 
    DataGrid, 
    GridColDef, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    gridVisibleSortedRowEntriesSelector,
    gridPageCountSelector,
    gridPageSelector,
    useGridSelector,    
    useGridApiContext  } from '@mui/x-data-grid';

import { makeStyles } from '@material-ui/core/styles';
    
    
import LoadingOverlay from '../components/common/LoadingOverlay';
import { responseHandle, errorHandle } from '../utils/callback-handle';

import InfoIcon from '@mui/icons-material/Info';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ExportIcon from '@mui/icons-material/GetApp';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { trim } from 'lodash';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex !important',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        minHeight: 'calc(100vh - 70px)',
        minWidth: '100vw',
        padding: theme.spacing(3),
        '& .MuiDataGrid-root': {
            border: 'none',
            fontSize: '0.8rem',
        }
    },
    left: {
        flex: '300px 0 0',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'stretch'                     
    },
    right: {
        flex: '1 0 0',
        margin: 0,
        marginLeft: '10px',
        padding: 0,      
    },
    titleContainer: {
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
        textAlign: 'center',
    },
    titleHead: {
        color: 'rgb(89, 203, 228)',
        fontSize: 48,
        fontWeight: 700,
        marginRight: 16,
    },
    titleTail: {
        fontSize: 48,
        fontWeight: 100,
        textTransform: 'uppercase',
    },
    card: {
        width: '100%',
        boxShadow: 'none !important',
        margin: 0,
        padding: 0,         
        '& .MuiCardHeader-root': {
            padding: '8px 16px',
            '& .MuiCardHeader-title': {
                fontSize: '16px'
            }
        },         
        '& .MuiCardContent-root': {
            padding: '0px 8px !important',
            '& .MuiDropzoneArea-root': {
                border: '1px solid lightgray'
            },
            '& .MuiDropzoneArea-text': {
                fontSize: '14px'
            },
            '& .MuiGrid-container': {
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }
        }         
    },
    cardAction: {
        alignItems: 'stretch !important',
        justifyContent: 'stretch',
        flexDirection: 'column'
    },
    row: {
        display: 'flex', 
        flexDirection: 'row'
    },
    textField: {
        width:  'calc(100% - 20px) !important',
        margin: '8px !important',
        '& .MuiSelect-select': {
            paddingTop: '8px !important',
            paddingBottom: '8px !important',            
        }
    },
    switchField: {
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width:  '200px'
    },
    dropZone: {
        minHeight: '150px',
    },
    pagination: {
        display: 'flex',
    }
}));


const configList = [
    {"id":"base-price","keyGen":"count","keyField":"id","keyType":"S", 
        "group": {"by": ["subRegion","gradeType"], "result": "specification"},
        "validators": {
            "Sub Region": {"field": "subRegion", "type": "S", "required": true}, 
            "Grade Type": {"field": "gradeType", "type": "S", "required": true}, 
            "OD mm": {"field": "OD", "type": "N", "required": true}, 
            "Mill": {"field": "mill", "type": "S", "required": true}, 
            "Value": {"field": "value", "type": "N", "required": false} 
        }
    },
    {"id":"schedule-wt","keyGen":"count","keyField":"id","keyType":"N",
        "validators": {
            "ND mm": {"field": "ND", "type": "N", "required": false}, 
            "OD mm": {"field": "OD", "type": "N", "required": false},
            "Schedule": {"field": "schedule", "type": "S", "required": true}, 
            "WT mm": {"field": "WT", "type": "N", "required": true},
        }
    },
    {"id":"pricing-shape","keyGen":"uuid","keyField":"id","keyType":"S", 
        "group": {"by": ["value"], "result": "specification", "groupResult": {"by": ["OD"], "result": "WT"}},
        "validators": {
            "Value": {"field": "value", "type": "N", "required": false}, 
            "OD mm": {"field": "OD", "type": "N", "required": true}, 
            "WT mm": {"field": "WT", "type": "N", "required": true}, 
        }
    },
    {"id":"minimum-quantity","keyGen":"uuid","keyField":"id","keyType":"S", 
        "group": {"by": ["minQty"], "result": "specification", "groupResult": {"by": ["OD"], "result": "WT"}},
        "validators": {
            "Min Qty": {"field": "minQty", "type": "N", "required": true}, 
            "OD mm": {"field": "OD", "type": "N", "required": true}, 
            "WT mm": {"field": "WT", "type": "N", "required": true}, 
        }
    },
    {"id":"mill","keyField":"abbreviation","keyType":"S",
        "validators": {
            "Abbreviation": {"field": "abbreviation", "type": "S", "required": true}, 
            "Coeficient": {"field": "coeficient", "type": "N", "required": true}, 
            "Country": {"field": "country", "type": "S", "required": true}, 
            "Name": {"field": "name", "type": "S", "required": true}, 
            "Ref": {"field": "ref", "type": "N", "required": true}, 
            "To Port 1": {"field": "toPort1", "type": "N", "required": false}, 
        }
    },
    {"id":"length","keyField":"description","keyType":"S", 
        "validators": {
            "Description": {"field": "description", "type": "S", "required": true}, 
            "Adder": {"field": "adder", "type": "N", "required": true}
        }
    },
    {"id":"grade-mill","keyField":"grade","keyType":"S",
        "group": {"by": ["grade"], "result": "mills", "reverseField" : "mill"},
        "validators": {
            "Grade": {"field": "grade", "type": "S", "required": true}, 
            "Mill": {"field": "mill", "type": "S", "required": true}
        }
    },
    {"id":"grade","keyGen":"count","keyField":"order","keyType":"N", 
        "validators": {
            "Grade Input": {"field": "in", "type": "S", "required": true}, 
            "Grade Output": {"field": "out", "type": "S", "required": true}, 
            "Norm Input": {"field": "normIn", "type": "S", "required": true}, 
            "Norm Output": {"field": "normOut", "type": "S", "required": true}, 
            "Extra": {"field": "extra", "type": "N", "required": true}, 
            "Delivery Time": {"field": "deliveryTime", "type": "S", "required": true},
            "Grade Adder": {"field": "gradeAdder", "type": "S", "required": true}, 
            "Cost Group": {"field": "costGroup", "type": "S", "required": true}, 
            "Grade Type": {"field": "gradeType", "type": "S", "required": true}  
        }
    },
    {"id":"detection","keyField":"in","keyType":"S", 
        "validators": {
            "In": {"field": "in", "type": "S", "required": true}, 
            "Out": {"field": "out", "type": "S", "required": true},
            "Value": {"field": "value", "type": "S", "required": false},
            "Order": {"field": "order", "type": "N", "required": true},
            "Type": {"field": "type", "type": "S", "required": true},
        }
    },
    {"id":"allocation-new","keyGen":"uuid","keyField":"id","keyType":"S", 
        "group": {"by": ["mill", "type", "level"], "result": "specification", "groupResult": {"by": ["OD"], "result": "WT"}},
        "validators": {
            "Mill": {"field": "mill", "type": "S", "required": true}, 
            "Type": {"field": "type", "type": "S", "required": true}, 
            "Level": {"field": "level", "type": "N", "required": true}, 
            "OD mm": {"field": "OD", "type": "N", "required": true}, 
            "WT mm": {"field": "WT", "type": "N", "required": true}, 
        }
    },
    {"id":"freight-cost-new","keyGen":"uuid","keyField":"id","keyType":"S",
        "responseAction": {"action":"get_template_data"}, 
        "validators": {
            "Mill": {"field": "mill", "type": "S", "required": true}, 
            "Place Of Departure": {"field": "placeOfDeparture", "type": "S", "required": true}, 
            "Region Of Departure": {"field": "regionOfDeparture", "type": "S", "required": true}, 
            "Country Of Departure": {"field": "countryOfDeparture", "type": "S", "required": true}, 
            "Selected Incoterm": {"field": "incoterm", "type": "S", "required": true}, 
            "Selected Place Of Destination": {"field": "portOfDestination", "type": "S", "required": true}, 
            "Selected Region Of Destination": {"field": "regionOfDestination", "type": "S", "required": true}, 
            "Selected Sub-Region Of Destination": {"field": "subRegionOfDestination", "type": "S", "required": true}, 
            "Selected Country Of Destination": {"field": "countryOfDestination", "type": "S", "required": true}, 
            "Alternative Incoterm To Be Offered?": {"field": "alternativeIncotermToBeOffered", "type": "S", "required": false}, 
            "Main Transport Solution": {"field": "mainTransportSolution", "type": "S", "required": false},
            "Final Incoterm Offered": {"field": "finalIncoterm", "type": "S", "required": true},
            "Final Destination Offered": {"field": "finalPortOfDestination", "type": "S", "required": true},
            "Final Country Offered": {"field": "finalCountryOfDestination", "type": "S", "required": true},
            "Final Subregion Of Destination": {"field": "finalSubregionOfDestination", "type": "S", "required": true},
            "Final Transportation Cost (USD/MT)": {"field": "finalTransportationCost", "type": "N", "required": true},
            "Final Transport Mode": {"field": "finalTransportMode", "type": "S", "required": false},
            "Final Transporation Price (USD/MT)": {"field": "finalTransporationPrice", "type": "N", "required": true},
            "Final Comment": {"field": "finalComment", "type": "S", "required": false}
        }
    },
    {"id":"cost","keyField":"id","keyType":"S", 
        "validators": {
            "OD (mm)": {"field": "OD", "type": "N", "required": true}, 
            "WT (mm)": {"field": "WT", "type": "N", "required": true}, 
            "Grade Group": {"field": "gradeGroup", "type": "S", "required": true}, 
            "Mill": {"field": "mill", "type": "S", "required": true}, 
            "MTP E/T": {"field": "mtp", "type": "N", "required": false}, 
            "Var. Costs E/T": {"field": "varCosts", "type": "N", "required": false},
            "Lenghts": {"field": "length", "type": "S", "required": true}, 
            "Currency": {"field": "currency", "type": "S", "required": true}, 
            "Date of Cost Update": {"field": "dateOfCostUpdate", "type": "S", "required": false},  
        }
    },
]; 

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
});   

 
const Home = () => {
    // const history = useHistory();
    const classes = useStyles();
    const { showSuccessMessage, showErrorMessage } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);
    const [selectedConfig, setSelectedConfig] = useState<string>('base-price');
    const [isClearData, setClearData] = useState<boolean>(false);
    const [uploadFiles, setUploadFiles] = useState<Array<FileObject>>([]);
    const [validationErrors, setValidationErrors] = useState<any>();
    const [responseSuccess, setResponseSuccess] = useState<any>();
    const [rows, setRows] = useState<Array<any>>([]);
    const [columns, setColumns] = useState<Array<GridColDef>>([]);
 
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isLoadingTable, setLoadingTable] = useState<boolean>(false);
  
    useEffect(() => {   
        console.log('load');
     }, []);
     
    useEffect(() => {
        setValidationErrors(null);
        setResponseSuccess(null);
        loadData();
    }, [selectedConfig]);
    
    const loadData = () => {
        if (selectedConfig) {
            const config = configList.find(x => x.id === selectedConfig);
            if (config) {
                setLoadingTable(true);
                setRows([]);
                const columns: GridColDef[] = [];
                for (const key of Object.keys(config.validators)) {
                    columns.push({ field: config.validators[key].field, headerName: key, minWidth: 250 })
                }
                setColumns(columns);
        

                api.post('/script', {action: 'get_data', tableName: process.env.REACT_APP_TABLE_ENV+'-smartengo-automatic-quote-'+config.id}).then((response: any) => {
                    const rows = reverse(config, response.data);
                    setRows(rows);
                }).catch((error) => {
                    showErrorMessage(errorHandle(error));
                }).finally(() => {
                    setLoadingTable(false);
                });
            }  
        }
    };

    const reverse = (config: any, data: any[]) => {
        let result = data;
        
        if (config.group) {
            result = []; 
            for (const d of data) {
                const resultGroup = d[config.group.result];  
                delete d[config.group.result];
                for (const rg of resultGroup) {
                    const obj = JSON.parse(JSON.stringify(d));
                    if (config.group.reverseField) {
                        obj[config.group.reverseField] = rg;
                    } else {
                        for (const key of Object.keys(rg)) {
                            obj[key] = rg[key];
                        }    
                    }
                    result.push(obj);
                }
            }
            if (config.group.groupResult) {
                const groupResult = []; 
                for (const d of result) {
                    const resultGroup = d[config.group.groupResult.result];  
                    delete d[config.group.groupResult.result];
                    for (const rg of resultGroup) {
                        const obj = JSON.parse(JSON.stringify(d));
                        // for (const key of Object.keys(rg)) {
                        //     obj[key] = rg[key];
                        // }
                        obj[config.group.groupResult.result] = rg;
                        groupResult.push(obj);
                    }
                }
                result = groupResult;     
            }
    
        }
        let id = 1;
        for (const r of result) {
            r['id'] = id++;
        }
        return result;
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setSelectedConfig(event.target.value);
    };         

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setClearData( event.target.checked);
    };     

    const handleClickDownloadTemplate = () => {
        window.open('/templates/'+selectedConfig+'-template.xlsx', '_blank');
    };

    const handleClickUpload = () => {
        setValidationErrors(null);
        setResponseSuccess(null);

        const file = uploadFiles[0].file;
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        const payload = JSON.parse(JSON.stringify(configList.find(x => x.id === selectedConfig)));
        payload['action'] = 'update_database';
        payload['tableName'] = process.env.REACT_APP_TABLE_ENV+'-smartengo-automatic-quote-'+payload.id;
        payload['clear'] = isClearData;

        
        reader.onload = async(e: ProgressEvent) => {
            const wb = read((e.target as FileReader).result);
            const ws = wb.Sheets[wb.SheetNames[0]];

            const columns = utils.sheet_to_json(ws, { header: 1 })[0];
            const columnErrors = validateColumns(payload, columns);
            console.log(columnErrors);
            if (columnErrors.Columns.length > 0) {
                setValidationErrors(columnErrors);
                showErrorMessage('Invalid Template!');
            } else {
                const rows = utils.sheet_to_json(ws);
                const transformedData = transform(payload, rows);
                console.log(transformedData);
                if (Object.keys(transformedData.errors).length > 0) {
                    setValidationErrors(transformedData.errors);
                    showErrorMessage('Update Data Fail!');
                } else {
                    setLoading(true);
                    payload['data'] = payload.id === 'freight-cost-new' ? transformfreightCostNew(transformedData.data) : transformedData.data;
                    try {
                        let response = null;
                        if (payload['clear']) {
                            const clearConfig = { action: 'clear_database', tableName: payload['tableName'], keyField: payload['keyField'] };
                            response = await api.post('/script', clearConfig);
                            delete payload['clear'];
                        }
                        response = await api.post('/script', payload);
                        if (payload.responseAction) {
                            response = await api.post('/script', payload.responseAction);
                        }
                        setResponseSuccess(responseHandle(response));
                        showSuccessMessage('Update Data Success!');

                        loadData();

                    } catch (err) {
                        showErrorMessage(errorHandle(err));
                    } finally {
                        setLoading(false);                    
                    }
                }   
            }
        };                   
    };

    const validateColumns = (config: any, columns) => {
        const result = { Columns: []};
        const keys = Object.keys(config.validators);
        for (const key of keys) {
            if (!columns.includes(key)) {
                result.Columns.push('Column ['+key+'] not found in the file!');
            }
        }
        return result;
    }

    const transformfreightCostNew = (transformedData: Array<any>) => {
        const result = [];   

        for (const td of transformedData) {
            if (td.countryOfDestination === 'United States of Americas') {
                td.countryOfDestination = 'USA';
            }
            if (td.countryOfDeparture === 'United States of Americas') {
                td.countryOfDeparture = 'USA';
            }
            if (td.finalCountryOffered === 'United States of Americas') {
                td.finalCountryOffered = 'USA';
            }
            if (td.portOfDestination === 'Rio de janeiro_Port') {
                td.portOfDestination = 'Rio de Janeiro_Port';
            }
            if (td.targetOfferedPortOfDestination === 'Rio de janeiro_Port') {
                td.targetOfferedPortOfDestination = 'Rio de Janeiro_Port';
            }
            if (td.finalPortOfDestination === 'Rio de janeiro_Port') {
                td.finalPortOfDestination = 'Rio de Janeiro_Port';
            }    

            td.mainTransportSolution = td.mainTransportSolution && td.mainTransportSolution === "0" ? '' : td.mainTransportSolution;
            td.finalTransportMode = td.finalTransportMode && td.finalTransportMode === "0" ? '' : td.finalTransportMode;


            td.comment = '';
            if (td.finalComment) {
                td.comment += td.finalComment;        
            }
            if (td.finalTransportMode) {
                td.comment += ' - ' + td.finalTransportMode;        
            }
            result.push(td);
        }
        return result;
    }

    const transform = (config: any, rows: Array<any>) => {
        const result = {data: [], errors: {}};
        const keys = Object.keys(config.validators);
        for (let row = 0; row < rows.length; row++) {
            const excelData = rows[row];
            const objData = {};
            for (const key of keys) {
                const validator = config.validators[key];
                let value = excelData[key];
                value =  value && (trim(value) === '?' || trim(value) === '-') ? validator.type === 'N' ? 0 : '' : value;                
                if (validator.required && (value === undefined || value === null || trim(value) === '')) {
                    addError(result.errors, row, 'Column ['+key+'] is required!');
                } else {
                    if (value && validator.type === 'N' && (typeof value !== 'number')) {
                        addError(result.errors, row, 'Column ['+key+'] is not a [number] value!');
                    } else {
                        objData[validator.field] = validator.type === 'N' ? value : value?.toString(); 
                    }
                }
            }
            result.data.push(objData);
        }
        
        if (config.group && Object.keys(result.errors).length === 0) {
            const groupResult = {data: [], errors: {}};
            for (const d of result.data) {
                let gd = groupResult.data.find(x => {
                    for (const by of config.group.by) {
                        if (x[by] !== d[by]) {
                            return false;
                        }
                    }
                    return true;
                });
                if (!gd) {
                    gd = {};
                    for (const by of config.group.by) {
                        gd[by] = d[by];
                    }
                    gd[config.group.result] = [];
                    groupResult.data.push(gd);
                }
                const sp = {};
                for (const key of Object.keys(d)) {
                    if (!config.group.by.includes(key)) {
                        if (config.group.reverseField) {
                            gd[config.group.result].push(d[key]);
                        } else {
                            sp[key] = d[key];
                        }
                    }
                }
                if (!config.group.reverseField) {
                    gd[config.group.result].push(sp);
                }
            }
            if (config.group.groupResult) {
                
                for (const gr of groupResult.data) {
                    const newResult = [];
                    for (const d of gr[config.group.result]) {
                        let gd = newResult.find(x => {
                            for (const by of config.group.groupResult.by) {
                                if (x[by] !== d[by]) {
                                    return false;
                                }
                            }
                            return true;
                        });           
                        if (!gd) {
                            gd = {};
                            for (const by of config.group.groupResult.by) {
                                gd[by] = d[by];
                            }
                            gd[config.group.groupResult.result] = [];
                            newResult.push(gd);
                        }
                        for (const key of Object.keys(d)) {
                            if (!config.group.groupResult.by.includes(key)) {
                                gd[config.group.groupResult.result].push(d[key]);
                            }
                        }
                    }
                    gr[config.group.result] = newResult;
                }
            }
            return groupResult;
        }
        return result;
    }

    const addError = (errors: any, row: number, message: string) => {
        const rowName = 'Row '+(row+1);
        if (!errors[rowName]) {
            errors[rowName] = [];
        }
        errors[rowName].push(message);
    }
    
    const CustomToolbar = () => {
        const apiRef = useGridApiContext();

        const handleExport = (options: any) => {
            const config = configList.find(x => x.id === selectedConfig);
            if (config) {
                const columns = Object.keys(config.validators).map(x => {
                    const result = config.validators[x];
                    result.headerName = x;
                    return result;
                });           
                
                let jw = rows;
                if (options.filtered) {
                    const data: any  = gridVisibleSortedRowEntriesSelector(apiRef);
                    
                    jw = data.map(x => {
                        const result = {};
                        for (const key of Object.keys(x.model)) {
                            const column = columns.find(x => x.field === key);
                            if (column) {
                                result[column.headerName] = column.type === 'N' ? parseFloat(x.model[key]) : x.model[key].toString();
                            }
                        }
                        return result;
                    });    
                }
                const ws = utils.json_to_sheet(jw);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, 'Data');
                writeFileXLSX(wb, selectedConfig + '-data.xlsx');
            }
        };
        
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton sx={{marginRight: '20px'}}/>
                <GridToolbarFilterButton sx={{marginRight: '20px'}} />
                <Button sx={{marginRight: '20px'}} variant="text" color="primary" size="small" startIcon={<ExportIcon />} onClick={() => handleExport({ filtered: true  })} >
                    DOWNLOAD DATA
               </Button>    
               {/* <Button sx={{marginRight: '20px'}} variant="text" color="success" size="small" startIcon={<ExportIcon />} onClick={() => handleExport({ filtered: false })} >
                    DOWNLOAD ALL DATA
               </Button>     */}
            </GridToolbarContainer>
        );
    }

    const CustomPagination = () => {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
      
        return (
          <Pagination
            color="primary"
            count={pageCount}
            page={page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}
          />
        );        
    }
   
    const renderTable = useMemo(() => <DataGrid 
        loading={isLoadingTable} 
        rows={rows} 
        columns={columns} 
        density="compact"
        pagination
        pageSize={18}
        rowsPerPageOptions={[100]}    
        components={{ Toolbar: CustomToolbar, Pagination: CustomPagination }}  
    />, [columns, rows, isLoadingTable]);

    const renderForm = useMemo(() => <>
        <CardHeader title="Select Options" />                            
        <CardContent>
            <div className={classes.row}>
                <TextField
                    select
                    label="Config:"
                    required
                    placeholder="Config"
                    id="config"
                    name="config"
                    className={classes.textField}
                    error={selectedConfig !== undefined && !selectedConfig}
                    value={selectedConfig}
                    onChange={handleInputChange}                            
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    InputLabelProps={{shrink: true}}>
                        {   
                            configList.map((config) => (
                                <MenuItem key={config.id} value={config.id}>
                                    {config.id}                                                
                                </MenuItem>
                            ))                                    
                        }
                </TextField>
                
          </div>
        </CardContent>
    </>, [selectedConfig, isClearData, configList]);

    const renderValidationErros = useMemo(() => validationErrors && <>
        <CardHeader title="Validation Errors" />                            
        <CardContent data-cy="cardContent" sx={{height: '100%', overflowY: 'auto'}}>
            {Object.keys(validationErrors).map(key => {
                return <div key={key} style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                    <div style={{margin: 0, fontSize: '0.8rem'}}>{key}</div>
                    <ul style={{margin: 0, paddingLeft: '25px'}}> 
                        {validationErrors[key].map(row => {
                            return <li key={row} style={{fontSize: '0.8rem', color: '#FB7171'}}>{row}</li>;
                        })}
                    </ul>
                </div>;
            })}
        </CardContent>

    </>, [validationErrors]);


    const renderResponseSuccess = useMemo(() => responseSuccess && <>
        <CardHeader title="Response Success" />                            
        <CardContent data-cy="cardContent" sx={{height: '100%', overflowY: 'auto'}}>
            <div style={{width: '100%', display: 'flex', fontSize: '0.8rem', color: '#59e480'}}>
                {JSON.stringify(responseSuccess, null, 2)}
            </div>
        </CardContent>

    </>, [responseSuccess]);

    const renderUpload = useMemo(() => <>
        <CardContent data-cy="cardContent">
            <DropzoneAreaBase
                dropzoneClass={classes.dropZone} 
                dropzoneText="Click or drag a Excel file to upload"
                acceptedFiles={["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]}
                maxFileSize={6291456} //6mb
                showFileNames={true}
                useChipsForPreview={true}
                filesLimit={1} 
                fileObjects={uploadFiles}
                onAdd={newFileObjs => {
                    setValidationErrors(null);
                    setResponseSuccess(null);    
                    setUploadFiles(newFileObjs);
                }}
                onDelete={deleteFileObj => {
                    setValidationErrors(null);
                    setResponseSuccess(null);    
                    setUploadFiles([]);
                }}
            />
        </CardContent>
        <CardActions className={classes.cardAction}>
            <Button sx={{margin: '0px 8px'}} data-cy="sendFile" disabled={ uploadFiles.length === 0 || selectedConfig === undefined } variant="contained" color="primary" size="small" startIcon={<CloudUploadIcon />} onClick={handleClickUpload} >
                Send File
            </Button>
            <Button sx={{margin: '8px 8px'}} data-cy="sendFile" disabled={ selectedConfig === undefined } variant="contained" color="secondary" size="small" startIcon={<InfoIcon />} onClick={handleClickDownloadTemplate} >
                Download Template
            </Button>
            <div className={classes.switchField}>
                <Switch 
                    data-cy="clear" 
                    name="clear" 
                    checked={isClearData}
                    onChange={handleSwitchChange}  
                    color="primary" />
                <b>Clear Table Data</b>
            </div>

        </CardActions>
    </>, [isClearData, uploadFiles]);

    
    return (
        <Container className={classes.root}>
            {currentUser && currentUser.roles.ADMIN && <>
                <Card className={classes.left}>
                    <Card className={classes.card} sx={{flex: '100px 0 0'}}>
                        {renderForm} 
                    </Card>
                    <Card className={classes.card} sx={{flex: '300px 0 0'}}>
                        {renderUpload} 
                    </Card>
                    <Card className={classes.card} sx={{flex: '1 0 0'}}>
                        {renderResponseSuccess}     
                        {renderValidationErros}                    
                    </Card>      
                </Card>
                <Card className={classes.right}>
                    {renderTable}
                </Card>
            </>}
            <LoadingOverlay open={isLoading} />
        </Container>
    );
};

export default Home;
